module.exports = "/lucky-balls/img/bonus_green/background.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_green/background.png
// module id = 921
// module chunks = 0